import { TranslateFn, cn } from "@garther/ui/libs";
import { AlertCircle } from "lucide-react";
import { memo } from "react";

interface Props {
  className?: string;
  t: TranslateFn;
}

const FeaturedEventsError = memo(({ className, t }: Props) => {
  return (
    <div className={cn("flex flex-col w-full items-center justify-center px-4", className)}>
      <div className="text-center space-y-0 max-w-lg">
        <div className="flex items-center justify-center gap-2 text-responsive-md font-normal text-red-500">
          <AlertCircle className="h-6 w-6 text-red-400" strokeWidth="1.5px" />
          {t("home.featuredEvents.errorTitle")}
        </div>
        <p className="text-responsive-base font-normal text-text-secondary">
          {t("home.featuredEvents.errorMessage")}
        </p>
      </div>
    </div>
  );
});

FeaturedEventsError.displayName = "FeaturedEventsError";
export default FeaturedEventsError;
